module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_shield_check_plus.e1850e34.svg";